// 행 끝에 버튼이 없을 때 컨트롤들을 한 줄로 정렬하는 데 도움이 됩니다

export const ControlsPadding = () => {
  return <div className="w-8"></div>;
};
